var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "colorForm",
              attrs: {
                model: _vm.colorForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.color_case") },
                    },
                    [
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "bottom",
                            width: "400",
                            trigger: "click",
                          },
                        },
                        [
                          _c("div", { staticStyle: { padding: "6px 10px" } }, [
                            _c(
                              "div",
                              [
                                _c("span", { staticClass: "color-label" }, [
                                  _vm._v(_vm._s(_vm.$t("chart.system_case"))),
                                ]),
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "chart.pls_slc_color_case"
                                      ),
                                      size: "mini",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeColorOption("value")
                                      },
                                    },
                                    model: {
                                      value: _vm.colorForm.value,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.colorForm, "value", $$v)
                                      },
                                      expression: "colorForm.value",
                                    },
                                  },
                                  _vm._l(_vm.colorCases, function (option) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: option.value,
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                        attrs: {
                                          label: option.name,
                                          value: option.value,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { float: "left" } },
                                          _vm._l(
                                            option.colors,
                                            function (c, index) {
                                              return _c("span", {
                                                key: index,
                                                style: {
                                                  width: "20px",
                                                  height: "20px",
                                                  float: "left",
                                                  backgroundColor: c,
                                                },
                                              })
                                            }
                                          ),
                                          0
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "4px",
                                            },
                                          },
                                          [_vm._v(_vm._s(option.name))]
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "2px" },
                                    attrs: { size: "mini", type: "text" },
                                    on: { click: _vm.resetCustomColor },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("commons.reset")))]
                                ),
                              ],
                              1
                            ),
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "margin-top": "10px",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "color-label" }, [
                                    _vm._v(_vm._s(_vm.$t("chart.custom_case"))),
                                  ]),
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          staticClass: "color-type",
                                          model: {
                                            value: _vm.customColor,
                                            callback: function ($$v) {
                                              _vm.customColor = $$v
                                            },
                                            expression: "customColor",
                                          },
                                        },
                                        _vm._l(
                                          _vm.colorForm.colors,
                                          function (c, index) {
                                            return _c(
                                              "el-radio",
                                              {
                                                key: index,
                                                staticStyle: { padding: "2px" },
                                                attrs: { label: c },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.switchColor(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("span", {
                                                  style: {
                                                    width: "20px",
                                                    height: "20px",
                                                    display: "inline-block",
                                                    backgroundColor: c,
                                                  },
                                                }),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "margin-top": "10px",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "color-label" }),
                                  _c(
                                    "span",
                                    [
                                      _c("el-color-picker", {
                                        staticClass: "color-picker-style",
                                        attrs: {
                                          predefine: _vm.predefineColors,
                                        },
                                        on: { change: _vm.switchColorCase },
                                        model: {
                                          value: _vm.customColor,
                                          callback: function ($$v) {
                                            _vm.customColor = $$v
                                          },
                                          expression: "customColor",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "margin-top": "2px",
                                width: "180px",
                              },
                              attrs: { slot: "reference" },
                              slot: "reference",
                            },
                            _vm._l(_vm.colorForm.colors, function (c, index) {
                              return _c("span", {
                                key: index,
                                style: {
                                  width: "20px",
                                  height: "20px",
                                  display: "inline-block",
                                  backgroundColor: c,
                                },
                              })
                            }),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.not_alpha") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeColorCase("alpha")
                          },
                        },
                        model: {
                          value: _vm.colorForm.alpha,
                          callback: function ($$v) {
                            _vm.$set(_vm.colorForm, "alpha", $$v)
                          },
                          expression: "colorForm.alpha",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-divider", [
                    _vm._v(_vm._s(_vm.$t("panel.card_color_matching"))),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.quota_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeColorCase("quotaColor")
                          },
                        },
                        model: {
                          value: _vm.colorForm.quotaColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.colorForm, "quotaColor", $$v)
                          },
                          expression: "colorForm.quotaColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.dimension_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeColorCase("dimensionColor")
                          },
                        },
                        model: {
                          value: _vm.colorForm.dimensionColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.colorForm, "dimensionColor", $$v)
                          },
                          expression: "colorForm.dimensionColor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", [
                _vm._v(_vm._s(_vm.$t("panel.table_color_matching"))),
              ]),
              _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.table_header_bg") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeColorCase("tableHeaderBgColor")
                          },
                        },
                        model: {
                          value: _vm.colorForm.tableHeaderBgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.colorForm, "tableHeaderBgColor", $$v)
                          },
                          expression: "colorForm.tableHeaderBgColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.table_item_bg") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeColorCase("tableItemBgColor")
                          },
                        },
                        model: {
                          value: _vm.colorForm.tableItemBgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.colorForm, "tableItemBgColor", $$v)
                          },
                          expression: "colorForm.tableItemBgColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.table_header_font_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeColorCase("tableHeaderFontColor")
                          },
                        },
                        model: {
                          value: _vm.colorForm.tableHeaderFontColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.colorForm, "tableHeaderFontColor", $$v)
                          },
                          expression: "colorForm.tableHeaderFontColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.table_item_font_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeColorCase("tableFontColor")
                          },
                        },
                        model: {
                          value: _vm.colorForm.tableFontColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.colorForm, "tableFontColor", $$v)
                          },
                          expression: "colorForm.tableFontColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.table_border_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeColorCase("tableBorderColor")
                          },
                        },
                        model: {
                          value: _vm.colorForm.tableBorderColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.colorForm, "tableBorderColor", $$v)
                          },
                          expression: "colorForm.tableBorderColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.table_scroll_bar_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: {
                          predefine: _vm.predefineColors,
                          "color-format": "rgb",
                          "show-alpha": "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeColorCase("tableScrollBarColor")
                          },
                        },
                        model: {
                          value: _vm.colorForm.tableScrollBarColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.colorForm, "tableScrollBarColor", $$v)
                          },
                          expression: "colorForm.tableScrollBarColor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }